import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Pagelife from "../../lego-pagelife";
import { cloneDeep, getQuery, getPageIdInfo } from "../../utils/common";
import { getCookie, setCookie } from "../../utils/cookie";
import lego from "../../lego";
import { getWinMeasurementPerfData } from "../../lego-perf/core/jobs/base";
var sendData = function sendData(obj) {
  lego.send(obj);
};
var initPvLister = function initPvLister(params, legoInit) {
  var pageIdInfo = getPageIdInfo();
  if (!pageIdInfo || !pageIdInfo.pageId) {
    return;
  }
  // 初始化上一个页面的信息
  var referrerObj = {
    refpagetype: '',
    refpagequery: '',
    refsubpageID: '',
    refsectionId: '',
    refsortId: ''
  };

  // 从cookie中获取
  try {
    var referrerObjCookie = getCookie('referrerObj');
    if (referrerObjCookie) {
      referrerObj = JSON.parse(decodeURIComponent(referrerObjCookie));
    }
  } catch (e) {}

  // 从url里面获取
  var refpagequery = getQuery('refpagequery');
  var refsubpageID = getQuery('refsubpageID');
  refpagequery && (referrerObj.refpagequery = refpagequery);
  refsubpageID && (referrerObj.refsubpageID = refsubpageID);
  var userBackup = {};
  if (legoInit) {
    userBackup = legoInit.getUserBackup() || {};
  }
  var PVPagetype = 'zpmshow';
  if (params.pagetype || userBackup.pagetype || pageIdInfo.isDetailPage) {
    PVPagetype = 'CommodityDetail';
  }
  sendData({
    pagetype: PVPagetype,
    actiontype: pageIdInfo === null || pageIdInfo === void 0 ? void 0 : pageIdInfo.pageId,
    backup: _objectSpread(_objectSpread(_objectSpread({}, userBackup), referrerObj), {}, {
      h5pageLoadingTime: getWinMeasurementPerfData('h5pageLoadingTime'),
      h5pageLoadedTime: getWinMeasurementPerfData('h5pageLoadedTime'),
      refsectionId: decodeURIComponent(getCookie('refsectionId')),
      refsortId: getCookie('refsortId')
    })
  });
  var refererCache = cloneDeep(referrerObj);
  // 更新参数在cookie中
  refererCache.refpagetype = pageIdInfo === null || pageIdInfo === void 0 ? void 0 : pageIdInfo.pageId;
  refererCache.refpagequery = params.pagequery || '';
  refererCache.refsubpageID = params.subpageID || '';
  setCookie({
    referrerObj: encodeURIComponent(JSON.stringify(refererCache))
  });
};
var autoPvLister = function autoPvLister(params, legoInit) {
  // 采用直接执行的方式，来保证首次是能发送的
  initPvLister(params, legoInit);
  // 如果是转转的客户端
  Pagelife.add('onLoad', function () {
    return initPvLister(params, legoInit);
  });
  try {
    window['ZZ_LEGO_ZPMSHOW_FUNS'] = function () {
      return initPvLister(params, legoInit);
    };
  } catch (error) {}
};
export default autoPvLister;